import axios from '@/plugins/axios'
import util from '@/services/util'
import constant from '@/services/constants'

import { XLSXWriter } from '@/services/xlsx'

const walletApiEndPoint = 'admin/wallet'

export default {
    namespaced: true,

    state: {
        wallets: [],
        total: 0
    },

    getters: {
        getWalletByCustomerId: () => async customerId => {
            return await axios.get(`${walletApiEndPoint}/${customerId}`)
        }
    },

    mutations: {
        setWallets (state, wallets) {
            state.wallets = wallets
        },

        setWalletTotal (state, total) {
            state.total = total
        }
    },

    actions: {
        async fetchWallets ({ commit }, query) {
            if (query?.from && query?.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(walletApiEndPoint, query))
            const { wallets, total } = response
            commit('setWallets', wallets)
            commit('setWalletTotal', total)
        },

        async getWalletReport ({ state, getters }, query) {
            if (query?.from && query?.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(walletApiEndPoint, query))
            const { wallets } = response
            const walletWithTransactions = []

            for (let i = 0; i < wallets.length; i++) {
                const wallet = wallets[i]
                let walletWithTransaction = null

                try {
                    walletWithTransaction = await getters.getWalletByCustomerId(wallet.CustomerID)
                } catch {
                    continue
                }

                walletWithTransactions.push(walletWithTransaction)
            }

            const writter = new XLSXWriter({
                title: 'Wallet',
                subject: 'Report',
                author: state.username
            })

            writter.setHeaders(constant.report.WALLET_HEADERS)

            walletWithTransactions.forEach(wallet => {
                const walletRows = [
                    wallet.CustomerID,
                    `${wallet.name} ${wallet.lastname}`,
                    util.getDDMMYYYYHHSSDateFormat(new Date(wallet.createdAt).getTime() + (60 * 420 * 1000))
                ]

                wallet.transactions.forEach(transaction => {
                    writter.addRow([
                        ...walletRows,
                        '100001',
                        util.getDDMMYYYYHHSSDateFormat(new Date(transaction.date).getTime() + (60 * 420 * 1000)),
                        transaction.name,
                        transaction.value
                    ])
                })
            })

            util.downloadBlob(
                writter.getXlsxBlob(),
                `AndamandaWallet_${util.getDDMMYYYYDateFormat(new Date())}.xlsx` ?? 'AndamandaWallet.xlsx'
            )
            return writter.getXlsxBlob()
        }
    }
}
